module.exports = __webpack_public_path__ + "01_long_brown.b0ba996a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_long_brown.png
// module id = oYLI
// module chunks = 0